import React from 'react'
import { Box, Link, Typography } from "@mui/material";

const Footer = () => {
	return (
		<Box sx={{ mt: 5, mb: 5}}>
			<Typography variant="body1" textAlign="center">
				Your info is being provided to
				REIN to create the quote <Link target="_blank" href="https://www.rein.ai/privacypolicy">Privacy Policy</Link>,
				&nbsp;<Link target="_blank" href="https://www.rein.ai/termsofservice">Do not sell or share my personal
					information</Link> REIN may receive a fee if you purchase the represented product
			</Typography>
		</Box>
	)
}

export default Footer
